import Button from "@/components/ui/button";

export default function WidgetEmptyPlaceholder({ onClick }: { onClick: () => void }) {
	return (
		<div className="flex w-full bg-white rounded-xl border border-gray-200 overflow-hidden items-stretch">
			<div className="border-r border-gray-200 shrink-0">
				<div className="relative w-full h-full max-w-sm" style={{ minHeight: "200px" }}>
					<img className="w-full h-full object-cover" src="/images/widget-templates/classic-rating-badge.jpg" alt="Widget Empty Placeholder" />
				</div>
			</div>
			<div className="flex flex-col justify-center space-y-4 p-6 px-8">
				<div>
					<h3 className="text-lg font-semibold text-gray-900 mb-2">Create your first widget</h3>
					<p className="text-sm text-gray-500">Build embeddable widgets that showcase your best testimonials and ratings.</p>
				</div>
				<Button type="button" onClick={onClick}>
					Create Widget
				</Button>
			</div>
		</div>
	);
}
